import React, { useEffect, useState } from 'react';
import { VALID_TYPE } from '../../../interfaces';
import AuthMfa from '../AuthMfa';
import { ECode, EMPTY_FN, get, includes } from '@libs/shared';

const MFA_ERROR_CODE = {
    PHONE_VERIFY: 41013, // 已有手机号，则直接进行二次验证
    PHONE_BIND: 41029 // 没有手机号，则先进行手机号绑定，绑定成功即认定为验证通过
};

/**
 * 二次验证(mfa)
 */
const useAuthMfa = () => {
    // 二次验证的手机号
    const [mfaPhoneNumber, setMfaPhoneNumber] = useState<string>('');
    // 手机号绑定前身份校验显示的邮箱
    const [phoneBindEmail, setPhoneBindEmail] = useState<string>('');
    // 支持的身份校验方式
    const [validTypeList, setValidTypeList] = useState<VALID_TYPE[]>([]);
    // 二次验证是否显示
    const [mfaDialogVisible, setMfaDialogVisible] = useState(false);
    // 二次验证回调函数
    const [callback, setCallback] = useState({
        onMfaSuccess: EMPTY_FN,
        onMfaFailed: EMPTY_FN
    });

    useEffect(() => {
        // 关闭时清空状态
        if (!mfaDialogVisible) {
            setMfaPhoneNumber('');
            setPhoneBindEmail('');
        }
    }, [mfaDialogVisible]);

    /**
     * 处理mfa报错
     *
     * @param error AxiosError
     * @param onMfaSuccess 二次验证成功回调
     * @param onMfaFailed 二次验证失败回调
     */
    const handleMfaError = (
        error: Record<string, any>,
        onMfaSuccess = EMPTY_FN,
        onMfaFailed = EMPTY_FN
    ) => {
        const err = get(error, 'response.data', {});
        const { code } = err;
        if ([MFA_ERROR_CODE.PHONE_VERIFY, ECode.USER_MFA_REQUIRED].includes(code)) {
            // 设置二次验证的手机号
            setMfaPhoneNumber(get(err, 'meta.phone', ''));
            setMfaDialogVisible(true);
        }
        if ([MFA_ERROR_CODE.PHONE_BIND, ECode.USER_PHONE_UNBIND_BEFORE_MFA].includes(code)) {
            setPhoneBindEmail(get(err, 'meta.email', ''));
            setValidTypeList(get(err, 'meta.verify_method_list', []));
            setMfaDialogVisible(true);
        }
        if (
            includes(
                [
                    MFA_ERROR_CODE.PHONE_VERIFY,
                    ECode.USER_MFA_REQUIRED,
                    MFA_ERROR_CODE.PHONE_BIND,
                    ECode.USER_PHONE_UNBIND_BEFORE_MFA
                ],
                code
            )
        ) {
            setCallback({
                onMfaSuccess,
                onMfaFailed
            });
        }
    };

    const renderAuthMfa = () => (
        <AuthMfa
            visible={mfaDialogVisible}
            phone={mfaPhoneNumber}
            email={phoneBindEmail}
            validTypeList={validTypeList}
            onMfaSuccess={callback.onMfaSuccess}
            onMfaFailed={callback.onMfaFailed}
            onClose={() => {
                setMfaDialogVisible(false);
            }}
        />
    );

    return {
        handleMfaError,
        renderAuthMfa
    };
};
export default useAuthMfa;
